
import React, { useState, useEffect, useRef} from 'react'
import '../../styles/gazette.css';


import * as Constants from '../../constants';
import BackLoader from '../../components/backloader'


import { TextField } from '@mui/material'
import DynamicIcon from '../dynamicicon';
import JisButton from '../controls/jisButton';
import JisCheckbox from '../controls/jisCheckbox';
import JisDialog from '../dialog';
import { source } from 'framer-motion/client';
import JisDialogForm from '../formdialog';
import PdfViewer from '../controls/pdfviewer';



function Gazette({token,caseid, filingtypeid,level='init',levelid, isPay=true,
     values="", children, onProceed,  feeId =null, collapsed=true, isShowAll=true,
      feetypeid,fillingsource="",sourceid=""}) { //all by the filingtype by level(init,spec,selected), values is used when type is selected, items are gazetteline by id seperated by coma
     
  
   

    const [isCollapse, setIsCollapse]= useState(collapsed)
    const [showAll, setShowAll] = useState(isShowAll)
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [selectedItems, setSelectedItems] = useState({});
  const[feeselObj, setFeeselObj] =useState({});
   const [feeselSet, setFeeselSet]=useState(new Set()) ;
    const [gazettes, setGazettes]=useState ([]);
  //  const [signs,setSigns]=useState([]);
    // const [collapse, setCollapse] = useState(false)
    const [collapsedCat, setCollapsedCat] = useState({})
    const [isLoading,setIsLoading]= useState(false);
    const [expandid, setExpandid] = useState(-1);
    const [category,setCategory]= useState({});
    const [inputqty, setInputQty] =useState([]);
    const [totalAmt, setTotalAmount]=useState(0);
    const scrollRef = useRef([]);
    const [activePrompt, setActivePrompt]= useState({open:false, activeId:0,numeric:1,bignumber:'', sp:{params:[]}});
    const [unspecAmount, setUnspecAmount] = useState ( {unspecamt1:'', unspecamt2:'', unspecamt3:'', unspecamt4:'', unspecamt5:''} );
    const [caseDetails , setCaseDetails]=useState( {} )
    //const [source, setSource] =useState(null);
    const [judicialfee, setJudicialFee] = useState(0);
    const [feespeclist,setSpecList]=useState(new Set());
    const [amountPaid, setAmountPaid] = useState(0);
    const [isPaid, setIsPaid] = useState(false);
    const [revisedreason, setRevisedReason] = useState('');
    const [revised, setRevised] = useState(false);
    const [move, setMove] = useState(null);
    const [isMove,setIsMove] = useState(false)
    const [isPreview, setIsPreview] = useState(false);
    const [previewUrl, setPreviewUrl] =  useState(false);
    const [moveDocs, setMovedocs]=useState([]);
    const [specialList, setSpecialList] = useState([]);
    const [docPermissionList, setDocPermissionList]=useState([]);
     const numricnote='Enter only numbers/figure and must be greater than zero';
    const [gazettelines, setGazetteLines] = useState([]);

    const check = (id, row) => {
        console.log(`selected is ${id}`);


        //if isPaid and the checked item already has a document attached to it
        //the system will show a dialog, inform about the document and, 
        // please check only document required item as replacement
        
        
        var Seal_gazette_line_id=717;
        var Seal_gazette_spec_id=97;
        if(row.isAssociated){
            console.log(`the associated id ${row.associatedLineId}`)
            Seal_gazette_line_id=row.associatedLineId;
          const k=  gazettelines.find((e)=>e.id==row.associatedLineId);
          if(k){
            console.log(`found ${k.gazetteId}`)
            Seal_gazette_spec_id=k.gazetteId;
          }
        }


        
        const updatedSelectedRows = new Set(selectedRows);
        const updatedSelectedItems = { ...selectedItems };
        const pams=new Set(docPermissionList);

        //start to handle move document
        if(feeselSet.has(row.id)){

            //if found, confirm its a check
            if(updatedSelectedRows.has(id)){
                //get the feeline item
                const vline= feeselObj[id];
                const gline=updatedSelectedItems[id];
                if(gline.isUpload){
                   
                console.log('the feeline object to transfer');
                setIsMove(true);

                return;
                }
                
            }
        }
        //end move document

        // Toggle the selection state for the clicked row
        if (updatedSelectedRows.has(id)) {
                //for deletion of judicial seal
                if(pams.has(id)){
                    
                    //get total qty, if same with Judicial then remove the judicial item
                    var ku=updatedSelectedItems[Seal_gazette_line_id];
                    var mu=updatedSelectedItems[id];
                    console.log(`ku.qty ${ku.qty}, ${mu.qty} *************************`)
                    if(ku.qty>mu.qty){
                        const km=ku.qty-mu.qty;
                        updatedSelectedItems[Seal_gazette_line_id]={...ku,qty:km};
                    }else{
                        //remove the item outrightly
                        updatedSelectedRows.delete(Seal_gazette_line_id);
                        delete updatedSelectedItems[Seal_gazette_line_id];
                        console.log('check at this point, 717 is removed **********');
                    }
                }
                // end delete
          //  console.log('this is just unchecked')
            updatedSelectedRows.delete(id);
            delete updatedSelectedItems[id];
            removeUnspefiedValue(id); //will check if the id is on list and clear value
        } else {
          //  console.log('this is just added')
            updatedSelectedRows.add(id);
            updatedSelectedItems[id] = {...row, qty:1};

         //   console.log('this is checked and it supose to show now')
            const sp= specialList.filter((cat) => cat.id ==id);
                if(sp.length>0){
                 setActivePrompt({...activePrompt, open:true, id, sp:sp[0], title:row.componentName}); //this is to load the parts
                }
           
             //check if the id is part
             
             if(pams.has(id)){
                //this is the guy
                //check if 717 already exist
               if(updatedSelectedRows.has(Seal_gazette_line_id)){
                    //update with the value
                    //increase the qty
                    var r=updatedSelectedItems[Seal_gazette_line_id]
                    var vrow={...r,qty:r.qty+1};
                    updatedSelectedItems[Seal_gazette_line_id] = vrow;
               } else{
                //add the 717 item with it row
                    const xs=gazettes.filter((x)=>x.id==Seal_gazette_spec_id);
                    const jud=xs[0].items.filter((k)=>k.id==Seal_gazette_line_id);
                    updatedSelectedRows.add(Seal_gazette_line_id);
                    updatedSelectedItems[Seal_gazette_line_id] = {...jud[0], qty:1};
               }
             }
        }

        setSelectedRows(new Set(updatedSelectedRows));
        setSelectedItems(updatedSelectedItems);
        var vll=Object.values(updatedSelectedItems);
        var subcatIds = new Set(vll.map(item => item.gazetteId));
        setSpecList(subcatIds);
       // console.log(updatedSelectedItems);
       onCalAmount(updatedSelectedItems);
    };

    const scrollToSection = id => {
        if (scrollRef.current.length) {
          scrollRef.current[id].scrollIntoView({behavior: 'smooth'});
        }
      };

  
    const clearItems = () => {
        onReset();
    } ;

    

    function isObjectEmpty() {
        return Object.keys(selectedItems).length === 0 && selectedItems.constructor === Object;
    }
   
const onSubmitRevised=(e)=>{
    e.preventDefault();
    proceedBtn();
}
    const proceedBtn= async()=>{
        //for account registration
        if(isPaid && (totalAmt-amountPaid)){
            //is revised must be revised
            if(!revised){
                setRevised(true);
                return;
            }
            setRevised(false);
        }

       /*  console.log(revisedreason);
        return; */
        if (isObjectEmpty() ) {
            alert('Please pick items before proceeding');
            return;
        } 
                const fee={amount:totalAmt,feeid:'abcd'};
                //internalFee, ExternalFee , Fee
                 var rdata={gazetteLines: Object.values(selectedItems)};
                 console.log(rdata);
                 console.log('above data for gazetteline selected')
              /*   onProceed(fee);
                return; */

                var gazetteLines=Object.values(selectedItems)
                const caseFeeLines = gazetteLines.map(item => ({
                gazettelineid: item.id,
                qty: item.qty,
                perItem: item.fee,
                isUpload: item.isUpload,
                itemType:item.itemType
                }));
                //var  =
        var rdata={caseFeeLines,CaseFeeId:feeId,feetypeid: feetypeid,revisedreason:revisedreason,source:fillingsource,sourceid,DocMoves:moveDocs  };
        
        console.log(JSON.stringify(rdata));
        try {
            setIsLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/process-gazette/${caseid}`, {
              method: 'POST',
              body: JSON.stringify(rdata),
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            
            const responseData = await resp.json();
            setIsLoading(false);
            console.log(responseData);
            if (responseData.code === 0 ) {
               /*  if(!responseData.isPaid){
                    window.location.replace(`${Constants.primarySite}/cms/specialredirect.aspx?casenumber=${responseData.casenumber}&casetype=litigation&caseid=${caseno}`)
                }else{
                    navigate(`/upload/${responseData.casefeeid}`) //this is for already paid. That is for Ministry of Justice
                } */

                     const fee={amount:totalAmt,feeid:responseData.id,isPaid: responseData.isPaid};
                //internalFee, ExternalFee , Fee
                onProceed(fee);
               
            }else {
             alert(responseData.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
           
          }
    }

    const toggleCollapse = (id) => {
        /* setCollapsedCat((prev) => ({
            ...prev,
            [id]: !prev[id]
        })) */
        console.info(`current id ${expandid} and newly selected ${id}`);
        if(id==expandid){
            setExpandid(-1);
        }else{
            setExpandid(id); 
        }
       
        
    }

    useEffect(() => {
   
       
        if(token!=null && caseid>0){
            onLoadGazette()
        }
        onLoadPermissions();
        onLoadDialogs();
       
      }, [token,caseid]);
 useEffect(() => {
   

        if(feeId!=null){
            onLoadFeeLines()
        }
        
       
      }, [feeId]);
      

      useEffect(() => {
        if(expandid==-1)
            return;

        scrollToSection(expandid);
 
       
      }, [expandid]);
      const onLoadGazette= async()=>{
        //for account registration
      //  console.log(`the calling url ${url}`);
      var req={caseid, filingtypeid,level,levelid, isPay, values}
        try {
            setIsLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/gazette`, { 
              method: 'POST',
              body:JSON.stringify(req) ,
              headers: {
                'Content-Type': 'application/json',
                'Authorization':  `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                var currentid=0;
                var gazlist=[];
                //buld dummy 
                data.gazettes.forEach(gaz => {
                 var idx=   gazlist.findIndex( function(el){return el.id==gaz.gazetteId});
                 if(idx==-1){
                    //new specification
                    var idsp= data.specs.findIndex( function(el){return el.id==gaz.gazetteId});
                   
                    if(idsp==-1){
                      //  console.log('idsp index '+idsp);
                      //  console.log('cannot find specification for this one');
                      //  console.log(gaz)
                    }else{
                        var spobj={id:data.specs[idsp].id, name:data.specs[idsp].title, items:[]}
                    spobj.items.push( { ...gaz,qty:1});
                    gazlist.push(spobj);
                    }
                        
                    
                 }else{
                    gazlist[idx].items.push( { ...gaz,qty:1});
                 }

                });
                console.log('constructed dummy');
                console.log(gazlist)
                setGazettes(gazlist);
                setCaseDetails(data.casedetails);
                setGazetteLines(data.gazettes);
               
            }else {    
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onLoadPermissions= async()=>{
            //for account registration
            
            try {
                const resp = await fetch(`${Constants.apiUrl}/setup/gazette-lines-seal-required`, { 
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                  },
                });
                const data = await resp.json();
                if(data.code==0){
                    console.log('list of permissions')
                    console.log(data.ids);
                    setDocPermissionList(data.ids);
                }
               
              } catch (error) {
               
                console.error(error);
                
              }
        }
    const onLoadDialogs= async()=>{
         
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/setup/gazette-lines-dialogs`, { 
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                  },
                });
                const data = await resp.json();
                if(data.code==0){
                    console.log("list of available dialogs")
                    console.log(data.items);
                    //process into the correct format
                   var nlist = [];
                    data.items.forEach(el => {
                        var f = {
                            id: el.id,
                            msg: el.dialogMsg,
                            params: [{
                                placeholder: el.claimHolder,
                                warning: numricnote, // Make sure 'numricnote' is defined
                                type: 'numeric'
                            }]
                        };
                        
                        if (el.isClaimAmount) {
                            f.params.push({ // Use push() instead of add()
                                placeholder: el.AmountHolder, // Make sure 'el.AmountHolder' is defined
                                warning: numricnote,
                                type: 'bignumber'
                            });
                        }
                        
                        nlist.push(f); // Use push() instead of add()
                    });

                    console.log(nlist);
                    setSpecialList(nlist);
                    }
               
              } catch (error) {
                
                console.error(error);
                
              }
        }

     const onLoadFeeLines= async()=>{
        //for account registration
      //  console.log(`the calling url ${url}`);
     // var req={caseid, filingtype,level,levelid, isPay, values}
        try {
            setIsLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-gazette/${feeId}`, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization':  `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setAmountPaid(data.fee);
                setIsPaid(data.isPaid);

                const selRows = new Set();
                const selspecs=new Set();
                const selItems = {  }; 
                const gazetteLines = data.payments.map(item => ({
               id : item.gazetteLineId ,
                qty: item.qty,
               fee : item.perItem,
                isUpload: item.isUpload,
                itemType:item.itemType,
                gazetteId: item.gazetteId,
                docs:item.docs
                }));
               for( const p of gazetteLines ){
                    selRows.add(p.id);
                    //get the spec id
                    selItems[p.id] = {...p};   
               }

               console.log(gazetteLines)

               console.log(selItems)

                    setSelectedRows(new Set(selRows));
                    setSelectedItems(selItems);
                    setFeeselObj (selItems); //this is the items
                    setFeeselSet (new Set(selRows)); //set that do not change
                  var vll=Object.values(selItems);
                    var subcatIds = new Set(vll.map(item => item.gazetteId));
                    setSpecList(subcatIds);
                    onCalAmount(selItems);
            }else {    
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
 
    const onQtyMain=(e,row,id)=>{
        //before apply 
       

        const updatedItems = { ...selectedItems };
         const oldqty=updatedItems[id].qty;
        var vrow={...row,qty:e.target.value};
        updatedItems[id] = vrow;


        //for seal
        const pams=new Set(docPermissionList);
        if(pams.has(id)){
            console.log(`old value ${oldqty} and new value ${e.target.value}`)
        const qty=parseInt(e.target.value) - parseInt(oldqty)
        updatedItems[717].qty+=qty; //first remove old value, then add the new one
        }
        


        setSelectedItems(updatedItems);
       // console.log(vrow);
        onCalAmount(updatedItems);

    }

    const onCalAmount=(main)=>{
        var mainAmt=0;
        var SubAmt=0;
     
      const arrMain=Object.values(main);
        for( const x of arrMain ){
           // console.log('in arrMain')
           // console.log(x);
            mainAmt+= (x.fee * x.qty);
        }

        setTotalAmount(mainAmt);
        console.log('Total amount calculated '+mainAmt);
    }

    const onSaveActiveDialog=()=>{
        //save active
        console.log('onSaveActiveDialog starting')
        console.log(activePrompt);
        const updatedItems = { ...selectedItems };
        // const updatedSigns = { ...selectedSignItems };
        
        const id=activePrompt.id;
        const val=activePrompt.numeric;
        console.log(`activePrompt.activeId ${id} activePrompt.numeric ${val}`)
        
        // setCardDetails({...cardDetails, [e.target.name]: e.target.value});
       // delete updatedSelectedItems[id];
       var calfee=0;
       if(activePrompt.sp.params.length>1){
        //it contain big data
        //calculate big data
            var bignumber=activePrompt.bignumber;
            addUnspefiedValue(id,bignumber);

           
            calfee=Constants.CalUnSpecified(bignumber);
        //end calculate big data
       }
       var row=updatedItems[id];

       var vrow= {...row,qty:val,fee: calfee>0?calfee:row.fee};
       updatedItems[id] = vrow;
       setSelectedItems(updatedItems);
         console.log(updatedItems);
         onCalAmount(updatedItems);

         setActivePrompt({open:false, activeId:0,numeric:1,bignumber:'', sp:{params:[]}})

    }
    const onCancelActiveDialog=()=>{
        setActivePrompt({...activePrompt,open:false, numeric:1, bignumber:''});
    }

    const onSetNumeric=(e)=>{
        var v=e.target.value;
        if(v<=0){
            v=1;
        }
        setActivePrompt({...activePrompt, numeric:v})
    }
    const onSetBigNumber=(e)=>{
        var v=e.target.value;
         if(isNaN(v))
            return; 

        //check if v is numeric and validate not below o
        if( v<=0){
            v='';
        }
        setActivePrompt({...activePrompt, bignumber:v})
    }

    const addUnspefiedValue = (id, amount)=>{
        //737,739,740,741,742
        //const [unspecAmount, setUnspecAmount] = useState ( {unsp1, unsp2, unsp3, unsp4, unsp5} );
        if(id==737){
            setUnspecAmount({...unspecAmount,unspecamt1:amount});
        }else if(id==739){
            setUnspecAmount({...unspecAmount,unspecamt2:amount});
        }
        else if(id==740){
            setUnspecAmount({...unspecAmount,unspecamt3:amount});
        }else if(id==741){
            setUnspecAmount({...unspecAmount,unspecamt4:amount});
        }else if(id==742){
            setUnspecAmount({...unspecAmount,unspecamt5:amount});
        }
    }

    const removeUnspefiedValue = (id)=>{
        if(id==737){
            setUnspecAmount({...unspecAmount,unspecamt1:''});
        }else if(id==739){
            setUnspecAmount({...unspecAmount,unspecamt2:''});
        }
        else if(id==740){
            setUnspecAmount({...unspecAmount,unspecamt3:''});
        }else if(id==741){
            setUnspecAmount({...unspecAmount,unspecamt4:''});
        }else if(id==742){
            setUnspecAmount({...unspecAmount,unspecamt5:''});
        }
    }
    const onReset=()=>{
        setSelectedRows(new Set()); setSelectedItems({});  setTotalAmount(0);
        
        setUnspecAmount( {unspecamt1:'', unspecamt2:'', unspecamt3:'', unspecamt4:'', unspecamt5:''} );
    }

    const onPreviewDoc =(d)=>{
        setIsPreview(true);
        const finalpath= Constants.RelativeFiletoRelative(d.filename);
        setPreviewUrl(finalpath )
        console.log(finalpath);
    }

    const onCancelMove=()=>{
        setIsMove(false)
        setMove(null);
    }

    const onMoveDoc=(row,doc,index)=>{
        //this will keep row and the doc to be removed
        //reduce the count on the original, 
        // if its only one doc and its moved, then its unchecked
        //any checked 

        setMove({row,doc,index});

    }

    const onAcceptMove=(row)=>{
        const _move={...move};
        //check if the role exist in the list

           const updatedSelectedRows = new Set(selectedRows);
        const updatedSelectedItems = { ...selectedItems };

        const md={sourceId:move.row.id,destinationId:row.id,docId:move.doc.id};

        if(row.id==_move.row.id){
            console.log('droping on same place')
            return;
        }
        if(updatedSelectedRows.has(row.id)){
            console.log('already selected before now');
            console.log(updatedSelectedItems[row.id].docs)
            const _docs=updatedSelectedItems[row.id].docs??[];
            console.log(_docs);
           updatedSelectedItems[row.id]={...row,docs:[..._docs,move.doc],qty:row.qty+1};

        }else{
            updatedSelectedRows.add(row.id);
             updatedSelectedItems[row.id] = {...row, qty:1,docs:[move.doc]};
             console.log('not selected selected before now');
        }

        //to remove from the move part
        var source_row=updatedSelectedItems[move.row.id];
        if(source_row.docs.length==1){
            //remove the item outrightly
            updatedSelectedRows.delete(move.row.id);
            delete updatedSelectedItems[move.row.id];
        }else {
            //more than 1, then remove 1
            const _docs=updatedSelectedItems[row.id].docs.filter((u)=>u.id!=move.doc.id)
            console.log(_docs);
           updatedSelectedItems[row.id]={...row,docs:[..._docs],qty:row.qty-1};
        }

        setSelectedRows(new Set(updatedSelectedRows));
        setSelectedItems(updatedSelectedItems);
        var vll=Object.values(updatedSelectedItems);
        var subcatIds = new Set(vll.map(item => item.gazetteId));
        setSpecList(subcatIds);
       // console.log(updatedSelectedItems);
       onCalAmount(updatedSelectedItems);
        setMovedocs([...moveDocs,md]);  //store details
        setMove(null)
    }

  return (
    <div className='gazette-list'>
    
        <div className="body">
            {children}
            <div style={{display:'flex'}}>
                <JisCheckbox label="Collapse All" value={isCollapse} onChange={(e)=>setIsCollapse(e) } /> 
                <JisCheckbox label ="Show All" value={showAll} onChange={(e)=>setShowAll(e) }  />
            </div>
            <div className="table-container">
                
                <table>
                    <thead>
                        <tr>
                            <th colSpan='2'>Select Specification</th>
                           
                            <th>Document Required</th>
                            <th>Document Quantity</th>
                           {isPaid && <th>Amount</th>} 
                        </tr>
                    </thead>
                    {gazettes.length>0 &&
                        gazettes.map((item, id) => { return (
                            (feespeclist.has(item.id) || showAll) && 
                            <tbody key={id} className={isCollapse?(expandid!=item.id ? 'collapse' : ''):''} ref={ref => (scrollRef.current[item.id] = ref)}>
                                <tr>
                                    <td className='span' colSpan='3'>
                                        {item.name} 
                                    </td>
                                    <td className='span'>
                                        <div className="icon" onClick={() => toggleCollapse(item.id)}>
                                          <DynamicIcon iname={`${expandid==item.id ? 'chevron-down' : 'chevron-up' }`} />
                                            
                                        </div>
                                    </td>
                                    {isPaid && <td className='span'></td>}
                                </tr>   
                                {
                                    item.items.map((row, idx) => { return (
                                        (selectedRows.has(row.id) || showAll) &&
                                        <tr className={selectedRows.has(row.id) ? 'specific-row picked' : 'specific-row'} key={idx}>
                                            <td>
                                                {Constants.NoteExcept(row.title)?'': <input 
                                                    type="checkbox" 
                                                    className='check'
                                                    id={row.id}
                                                    onClick={() => check(row.id, row)}
                                                    checked={selectedRows.has(row.id)}
                                                    disabled={  row.id==717}
                                                />}
                                               
                                            </td>
                                           {Constants.NoteExcept(row.title)?
                                           <td className='specification' style={{color:'red', fontWeight:'bold'}}>{row.title}  </td>:
                                           <td className='specification'>{row.title} {row.itemType=='External'?'':'***'} </td>
                                        } 
                                            <td className='document-upload'>
                                                {row.isUpload  ? <div className='groupbtn'><p>Document Required</p> 
                                               {isPaid && move!=null && <div onClick={()=>onAcceptMove(row)} style={{display:'flex',alignItems:'center', cursor:'pointer'}}>
                                                    <DynamicIcon iname="cloud-download" /></div>} 
                                                    </div> : ''} 
                                                { selectedRows.has(row.id) && selectedItems[row.id]?.docs?.length>0 && 

                                                selectedItems[row.id]?.docs.map((doc, id) => { return (<div>
                                                     <div className='groupbtn'><JisButton onClick={()=>onPreviewDoc(doc)}>Preview Document</JisButton>
                                                   {isPaid && move==null && <div style={{display:'flex',alignItems:'center', cursor:'grab'}} 
                                                     onClick={()=> onMoveDoc(row,doc,id)}><DynamicIcon iname="move" /></div>}   </div>
                                                </div>)})
                                               } 
                                            </td>
                                            <td className='quantity'>
                                                {
                                                    (!Constants.NoteExcept(row.componentName)) ? 
                                                    <input type="number" className='number' min={1} 
                                                    value={selectedItems[row.id]?.qty==undefined?1:selectedItems[row.id]?.qty} 
                                                    onChange={(e)=>onQtyMain(e,row,row.id)} id='numOfdocs' 
                                                    disabled={  !selectedRows.has(row.id) || row.id==717}/> : ''
                                                }
                                            </td>
                                            {isPaid && <td><span>N{Constants.formatCurrency(row.fee) }</span> </td>}
                                        </tr>
                                    )})
                                }
                            </tbody>
                        )})
                    }
                </table>
            </div>
         

            <div className="total-pay">
                <div className="reset-back">
                    <JisButton onClick={() => clearItems()} iname="refresh">Reset Selection</JisButton>
                </div>
                <div className="total-fee">
                    {/* <p className="total">Total Fee (₦): <span>{totalAmount}</span></p> */}
                    <h2 className='amount-after'>Total Fee  (₦) : <span>{isPay==false?0: Constants.formatCurrency(totalAmt)}</span></h2>
                    {isPaid==true && <div className='amount-after' style={{fontSize:16}}>Total Balance (₦): <span>{ Constants.formatCurrency(totalAmt-amountPaid)}</span></div>}
                    <JisButton icon="arrow-right" onClick={() => proceedBtn()}>Proceed</JisButton>
                </div>
            </div>
        </div>
        <BackLoader open={isLoading}  />
           
        {activePrompt.open && <div className={ "dialog-box open" }>
                    
                   
                        <div className="wrapper">
                        <h3>{activePrompt.title}</h3>
                        <div className="main">
                            <p>{activePrompt.sp.msg}</p>
                            <div style={{marginTop:16}}>
                                {activePrompt.sp.params.length==1 && <div>
                                
                                    <TextField id="outlined-basic" label="Qty" variant="outlined" type="number"  
                                    value={activePrompt.numeric} onChange={onSetNumeric} min={1}  helperText={numricnote}  />
                                
                                    </div>}
                                    {activePrompt.sp.params.length==2 && <div>
                                    

                                    <TextField id="outlined-basic" label="Amount" variant="outlined"  
                                    value={activePrompt.bignumber} onChange={onSetBigNumber} min={1} helperText={numricnote}  />
                                    <div style={{margin:16}}>
                                    <strong>{activePrompt.sp.params[1].placeholder}</strong>
                                    </div>
                                    <TextField id="outlined-basic" label="Qty" variant="outlined" type="number"  
                                    value={activePrompt.numeric} onChange={onSetNumeric} min={1} helperText={numricnote}  />
                                    
                                    </div>}
                            </div>
                            <div className="btns">
                                <button onClick={onCancelActiveDialog} className='red'>Cancel</button>
                                <JisButton icon="save"  onClick={onSaveActiveDialog}>Ok</JisButton>
                            </div>  
                        </div>
                    </div>
                 

                    
                </div>}


  
{isPreview && <JisDialogForm title="Document Preview" onClose={() =>setIsPreview(false)}>
          <div>
            <div style={{height:'90vh'}}> <PdfViewer  pdfUrl={previewUrl}/>
                               
                                </div>
          </div>
</JisDialogForm>}

        {revised && 
        <JisDialogForm title="Review Reason" onClose={()=> setRevised(false)}>
          <form onSubmit={onSubmitRevised}>
                <div>
                
                    <div  className="input-group">
                        <label>Comment <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <textarea placeholder=' Comment' required={true}  value={revisedreason}
                    onChange={(e)=>setRevisedReason(e.target.value ) }  />
                        </div>
                    </div>   
                    <div className='groupbtn'>
                        <JisButton type="submit">Save </JisButton>     
                        <JisButton type="button" variant='outline' onClick={()=> setRevised(false)}>Cancel </JisButton> 

                    </div>          
                    
                </div>
            </form>
        </JisDialogForm>} 

        {isMove && 
        <JisDialogForm title="Move Document" onClose={onCancelMove}>
          <div>
                <div>
                
                   <p>The Item selected has a document on it, you can only move the document to uncheck it. Click on the this sign <DynamicIcon iname="move" /> to move the document.</p>            
                 
                 <div className='groupbtn'>
                        
                    <JisButton type="button" variant='outline' onClick={onCancelMove}>Cancel </JisButton> 
                </div>   

                </div>
            </div>
        </JisDialogForm>} 
    
    </div>
  )
}

export default Gazette
